import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ErrorText = styled.p`
  color: #dc2626;
  font-size: 13px;
  margin: 8px 0 0;
`;

export const InfoText = styled.p`
  color: #6b7280;
  font-size: 13px;
  margin: 0 0 12px;
`;
